import { queryOptions } from '@tanstack/react-query'

import { knockOutFetcher } from '@/libs/fetcher/presets'

/**
 * Event kind groups（cdc-web `useEventKindGroups` 的 RQ 版）：
 * `/predictions/public/api/v1/event_kind_groups?asset_type=…`。
 *
 * 用途：卡片页头图标兜底链 `event.logo_url ?? group.icon`——group 图标不在
 * 事件 payload 上，按 `event_kind_group_id` 在这里查（stag 已验证公开可用）。
 */

export interface PredictionEventKindGroup {
  id: string
  name: string
  display_name: string
  status: string
  ordering: number
  icon: string
  asset_type: string
  /** APP 侧会下 null 的占位组（SPORTS 等），过滤掉（cdc-web 同款处理）。 */
  event_kinds: string[] | null
  have_active_events: boolean
  slug: string
}

interface EventKindGroupsResponse {
  has_more: boolean
  data: PredictionEventKindGroup[]
}

const fetchEventKindGroups = async (assetType: string): Promise<PredictionEventKindGroup[]> => {
  const res = await knockOutFetcher<EventKindGroupsResponse>(
    '/api/v1/event_kind_groups',
    { queries: { asset_type: assetType } },
    { successResponseDataProperty: '' },
  )
  return (res?.data ?? []).filter(group => group.event_kinds !== null)
}

export function predictionEventKindGroupsQueryOptions(assetType: string) {
  return queryOptions({
    queryKey: ['prediction', 'event-kind-groups', assetType] as const,
    queryFn: () => fetchEventKindGroups(assetType),
    // 组 meta 变化极慢，长 stale + 不轮询。
    staleTime: 10 * 60 * 1000,
  })
}
